<template>
  <div class="has-content">
    <f7-link @click="rootExpanded = !rootExpanded">
      <div class="parent-item-title">
        <div>工程信息</div>
        <div>
          <f7-icon :fa="rootExpanded ? 'angle-up' : 'angle-right'"></f7-icon>
        </div>
      </div>
    </f7-link>
    <div class="parent-item-content" v-show="rootExpanded">
      <div>
        <span class="parent-item-label">工程名称：</span>
        <span class="parent-item-text">{{ project.name }}</span>
      </div>
      <div>
        <span class="parent-item-label">开竣工日期：</span>
        <span class="parent-item-text">
          {{ project.planStartupTime | formatDateValue }}
          至
          {{ project.planCompletedTime | formatDateValue }}
        </span>
      </div>
      <div>
        <span class="parent-item-label">工程地址：</span>
        <span class="parent-item-text">{{ project.address }}</span>
      </div>
      <div>
        <span class="parent-item-label">工程规模：</span>
        <span class="parent-item-text">
          {{ project.projectSize | formatNumberVal }} {{ project.sizeUnitDesc }}
        </span>
      </div>
      <div>
        <span class="parent-item-label">建设单位：</span>
        <span class="parent-item-text">{{ project.buildDepartment }}</span>
      </div>
      <div>
        <span class="parent-item-label">总包单位：</span>
        <span class="parent-item-text">{{ project.totalDepartment }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import currency from 'currency.js';
import { dateFormat } from '@/util/dateUtils';

export default {
  props: ['project'],
  data() {
    return {
      rootExpanded: true,
    };
  },
  filters: {
    formatDateValue: value => dateFormat(value),
    formatNumberVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '--';
    },
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .parent-area {
    background-color: $panel-bg-color;
  }

  .parent-item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.5rem;
    background-color: $panel-bg-color;
    font-size: 1rem;
  }

  .parent-item-content {
    background-color: #fff8ed;
    font-size: 0.9rem;
    padding: 0.5rem 0.5rem;
    line-height: 1.5rem;
  }

  .parent-item-label {
    color: $second-font-color;
  }

  .parent-item-text {
    color: $font-color;
  }

</style>



// WEBPACK FOOTER //
// src/components/ReleaseHeader.vue